import axios from "axios";
import { apiUserDetailsUpdate } from "../../../sdk";
import { ContactInformation } from "../../../sdkStructs";

export async function changeContactInfo(data: ContactInformation, token: string) {
  try {
    await apiUserDetailsUpdate(token, data);

  } catch (e) {
    if (!axios.isAxiosError(e)) return;
    console.log("ERROR UPDATING USER INFORMATION:", e.response);
  }
}
